<template>
  <div v-if="oneUnitPerPitch" v-bind="$attrs" class="one-unit-per-pitch">
    <div class="unit-per-pitch">
      <translate :tt="{ categoriesText }">
        One {categoriesText} allowed per pitch
      </translate>
      <pu-popover>
        <template #content>
          <div>
            <translate :tt="{ categoriesText }">
              Only one {categoriesText} unit allowed per pitch (not including
              pup tent, awning, gazebo).
            </translate>
          </div>
        </template>
      </pu-popover>
    </div>
    <translate tag="p" v-if="additionalUnitsMsg">
      Additional units require additional pitches - quick book via Make another
      booking like this after making your booking.
    </translate>
  </div>
  <div v-else v-bind="$attrs" class="unit-per-pitch">
    <translate :tt="{ categoriesText }">
      Multiple {categoriesText} allowed per pitch
    </translate>
    <pu-popover>
      <template #content>
        <div>
          <translate :tt="{ categoriesText }">
            Multiple {categoriesText} are allowed per pitch.
          </translate>
          <translate tag="p">
            Please ensure your units will fit within the pitch size listed, and
            that you do not exceed the max. persons for this pitch.
          </translate>
        </div>
      </template>
    </pu-popover>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { AllowedSubcategory } from '../../apps/campsite-details/types'

@Component
class UnitPerPitch extends Vue {
  @Prop({ required: true })
  oneUnitPerPitch: boolean

  @Prop({ default: true })
  additionalUnitsMsg: boolean

  @Prop({ required: true })
  allowedSubcategories: AllowedSubcategory[]

  get categoriesText() {
    return this.allowedSubcategories.join(` ${this.$t('or')} `)
  }
}

export default toNative(UnitPerPitch)
</script>

<style scoped>
.unit-per-pitch {
  position: relative;
  font-size: var(--body);
}

.unit-per-pitch :deep(aside) {
  margin: 0 0 0 0.5em;
}

.one-unit-per-pitch {
  margin: 1em 0;
}

.one-unit-per-pitch p {
  margin-top: 1em;
  font-size: var(--body);
}
</style>
